package com.downdogapp

import kotlinx.browser.window
import kotlin.math.abs
import kotlin.math.roundToInt

fun jsObj(vararg pairs: Pair<Any, Any?>): dynamic {
  val result = js("{}")
  for (pair in pairs) {
    pair.second?.let {
      result[pair.first] = it
    }
  }
  return result
}

fun getUrlHash() = window.location.hash.let {
  if (it.isNotEmpty()) it.substringAfter("#") else null
}

fun format(
  duration: Duration,
  displayMilliSeconds: Boolean = false
): String {
  val s = abs(duration.seconds)
  val hours = (s / 3600).toInt()
  val minutes = (s / 60).toInt() % 60
  val seconds = s.toInt() % 60
  val ms = (1000 * (s - 60 * minutes - seconds)).roundToInt()

  val adjustedSeconds = seconds + (if (ms == 1000) 1 else 0)
  val adjustedMs = if (ms == 1000) 0 else ms

  return buildString {
    if (duration < Duration.ZERO) {
      append("-")
    }
    if (hours != 0) {
      append("$hours:")
    }
    append(if (minutes < 10) "0$minutes:" else "$minutes:")
    append(if (adjustedSeconds < 10) "0$adjustedSeconds" else "$adjustedSeconds")
    if (displayMilliSeconds) {
      val str = when {
        adjustedMs < 10 -> "00$adjustedMs"
        adjustedMs < 100 -> "0$adjustedMs"
        else -> adjustedMs.toString()
      }
      append(".$str")
    }
  }
}

actual fun Double.toString(decimalPlaces: Int) =
  if (this == 0.0)
    "0"
  else
    (asDynamic().toFixed(decimalPlaces) as String).let {
      if ('.' in it)
        it.substringBefore('.') +
        it.substringAfter('.').trimEnd('0').let {
          if (it.isEmpty())
            ""
          else
            ".$it"
        }
      else
        it
    }

@Suppress("UnsafeCastFromDynamic")
fun encodeURIComponent(value: String): String = window.asDynamic().encodeURIComponent(value)
